const AUTH_HEADERS = ['uid', 'access-token', 'client', 'expiry', 'token-type'];
const DATA_KEYS = ['closed_modules', 'riskModalDate'];

export function setAuthData(data) {
  if (data) {
    AUTH_HEADERS.forEach(key => {
      localStorage[key] = data[key];
    });
  }
}

export function getAuthData() {
  const data = {};
  AUTH_HEADERS.forEach(key => {
    data[key] = localStorage[key];
  });
  return data;
}

export function clearAuthData() {
  console.warn('%c clearAuthData()', 'color: blue'); // eslint-disable-line no-console

  [...AUTH_HEADERS, ...DATA_KEYS].forEach(key => delete localStorage[key]);
}



// WEBPACK FOOTER //
// ./src/utils/authData.js